<template>
  <div class="rounded-2xl border-solid border border-semiDarkgrey bg-white mb-4">
    <div class="relative flex items-center">
      <slot></slot>
      <button class="w-10 h-10 flex justify-center items-center rounded-4xl hover:bg-slate-100 mr-4"
        @click="toggleDetails">
        <img src="/img/icons/dropdown-arrow.svg" alt="" class="transition-all ease-in-out duration-500"
          :class="{ 'rotate-180': showDetails }">
      </button>
    </div>
    <div class="transition-all overflow-hidden max-h-0 ease-in-out duration-500 flex flex-col"
      :class="{ 'max-h-screen': showDetails }">
      <div class="m-6">
        <flight-route v-for="(route, index) in flight.routes" :key="route.id" :route="route" :layovers="flight.layovers"
          :index="index" :num-routes="flight.routes.length">
        </flight-route>
      </div>
    </div>
    <div class="md:hidden border-t border-solid border-semiDarkgrey p-3 flex justify-center items-center">
      <slot name="footer"></slot>
    </div>
  </div>
</template>


<script>
import moment from 'moment';
import FlightRoute from "./FlightRoute.vue";
import { minutesToHoursMinutes } from '../helpers';

export default {
  components: { FlightRoute },
  props: {
    flight: {
      type: Object,
      required: true,
    },
    opened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDetails: false
    }
  },
  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails
    },
    selectFlight(flight) {
      this.$emit('select-flight', flight)
    },
    showHour(time) {
      return moment(time).format('HH:mm')
    },
    showHours(minutes) {
      return minutesToHoursMinutes(minutes)
    }
  },
  created() {
    if (this.opened) this.showDetails = true
  }

}
</script>

<style lang="scss">
@import "../../../../sass/_variables.scss";

@media (min-width: 841px) {
  .xvIywb {
    grid-column-start: 2;
    grid-row: 1 / span 4;
    margin: 5px 16px 8px 0;
  }
}

.xvIywb {
  align-self: stretch;
  flex-direction: column;
}

.T6Yut {
  border: 2px solid $semiDarkgrey;
  border-radius: 12px;
  box-sizing: border-box;
  height: 12px;
  width: 12px;
}

.Vd4i6d {
  border-right: 4px dotted $semiDarkgrey;
  flex: 1;
  margin-bottom: 4px;
  margin-top: 4px;
  width: 4px;
  margin-left: 3px;
}

.T6Yut {
  border: 2px solid $semiDarkgrey;
  border-radius: 12px;
  box-sizing: border-box;
  height: 12px;
  width: 12px;
}
</style>
